(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/areas/play/containers/game-launcher-wrapper.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/areas/play/containers/game-launcher-wrapper.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const GameLoader = svs.tickets.next.areas.play.components.GameLoader;
const BubbleWinMessage = svs.tur.bubbleWinMessage.components.BubbleWinMessage;
const _svs$ticketgames$tick = svs.ticketgames.ticketUtility.components,
  GameLauncherLeia = _svs$ticketgames$tick.GameLauncherLeia,
  GameWrapper = _svs$ticketgames$tick.GameWrapper,
  GameContext = _svs$ticketgames$tick.GameContext,
  LoaderTicket = _svs$ticketgames$tick.LoaderTicket,
  TicketIdPopper = _svs$ticketgames$tick.TicketIdPopper,
  Receipt = _svs$ticketgames$tick.Receipt;
const _svs$ticketgames$tick2 = svs.ticketgames.ticketUtility.utils,
  resizeFromFullscreen = _svs$ticketgames$tick2.resizeFromFullscreen,
  resizeFromTicketInfo = _svs$ticketgames$tick2.resizeFromTicketInfo,
  useDefaultEventsLeiaFactory = _svs$ticketgames$tick2.useDefaultEventsLeiaFactory,
  useScratchDefaultEventsLeiaFactory = _svs$ticketgames$tick2.useScratchDefaultEventsLeiaFactory;
const useCustomEvents = svs.tickets.next.areas.play.containers.useCustomEvents;
const NextTopBar = svs.tickets.next.components.NextTopBar;
const TicketPodiumStageFrame = svs.tickets.next.components.ticketCarousel.TicketPodiumStageFrame;
const BottomSheet = svs.tickets.next.components.bottomsheet.BottomSheet;
const Image = svs.content.image_v2.Image;
const Button = svs.ui.ReactButton;
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useCallback = _React.useCallback,
  useReducer = _React.useReducer,
  useMemo = _React.useMemo,
  useRef = _React.useRef;
const NOOP = () => {};
const PLAY_CONTROLS_DELAY_MS = 340;
const PLAY_STAGE_EXPAND_DELAY_MS = 220;
const PLAY_LOADER_GROW_DURATION_MS = 720;
const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
const applyLauncherSize = (container, size) => {
  if (!container || !(size !== null && size !== void 0 && size.width) || !(size !== null && size !== void 0 && size.height)) {
    return;
  }
  container.style.width = "".concat(size.width, "px");
  container.style.height = "".concat(size.height, "px");
};
const getContainedWidth = _ref => {
  let containerHeight = _ref.containerHeight,
    containerWidth = _ref.containerWidth,
    ticketInfo = _ref.ticketInfo;
  const width = Number(ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.width);
  const height = Number(ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.height);
  if (!containerWidth || !containerHeight || !width || !height) {
    return 0;
  }
  return Math.min(containerWidth, containerHeight * (width / height));
};
const getPickSizedWidth = ticketInfo => {
  var _document$documentEle, _document$documentEle2;
  if (typeof window === 'undefined') {
    return Number(ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.width) || 0;
  }
  const ticketWidth = Number(ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.width) || 0;
  const viewportWidth = window.innerWidth || ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.clientWidth) || 0;
  const viewportHeight = window.innerHeight || ((_document$documentEle2 = document.documentElement) === null || _document$documentEle2 === void 0 ? void 0 : _document$documentEle2.clientHeight) || 0;
  const isMobile = viewportWidth < 1024;
  if (isMobile) {
    const containerWidth = Math.min(Math.max(viewportWidth - 72, 0), Math.min(ticketWidth, 390));
    const containerHeight = clamp(viewportHeight - 392, 250, 430);
    return getContainedWidth({
      containerHeight,
      containerWidth,
      ticketInfo
    });
  }
  const containerHeight = clamp(viewportHeight - 208, 200, 600);
  return getContainedWidth({
    containerHeight,
    containerWidth: ticketWidth,
    ticketInfo
  });
};
const getStoredPickSizedWidth = ticketInfo => {
  var _svs$tickets$next$uti, _svs$tickets$next$uti2, _pickSize$ticketType, _pickSize$ticketType$, _ticketInfo$type, _ticketInfo$type$toLo;
  const pickSize = (_svs$tickets$next$uti = (_svs$tickets$next$uti2 = svs.tickets.next.utils.utils).getTicketPickSize) === null || _svs$tickets$next$uti === void 0 ? void 0 : _svs$tickets$next$uti.call(_svs$tickets$next$uti2);
  const storedTicketType = pickSize === null || pickSize === void 0 || (_pickSize$ticketType = pickSize.ticketType) === null || _pickSize$ticketType === void 0 || (_pickSize$ticketType$ = _pickSize$ticketType.toLowerCase) === null || _pickSize$ticketType$ === void 0 ? void 0 : _pickSize$ticketType$.call(_pickSize$ticketType);
  const currentTicketType = ticketInfo === null || ticketInfo === void 0 || (_ticketInfo$type = ticketInfo.type) === null || _ticketInfo$type === void 0 || (_ticketInfo$type$toLo = _ticketInfo$type.toLowerCase) === null || _ticketInfo$type$toLo === void 0 ? void 0 : _ticketInfo$type$toLo.call(_ticketInfo$type);
  if (!(pickSize !== null && pickSize !== void 0 && pickSize.visualWidth) || !storedTicketType || storedTicketType !== currentTicketType) {
    return 0;
  }
  const visualWidth = Number(pickSize.visualWidth);
  return Number.isFinite(visualWidth) && visualWidth > 0 ? visualWidth : 0;
};
const getViewportWidth = () => {
  var _document$documentEle3;
  if (typeof window === 'undefined') {
    return 0;
  }
  return window.innerWidth || ((_document$documentEle3 = document.documentElement) === null || _document$documentEle3 === void 0 ? void 0 : _document$documentEle3.clientWidth) || 0;
};
const getFallbackPlayStartScale = () => getViewportWidth() < 1024 ? 0.86 : 0.92;
const getVisiblePlayStartLimit = () => getViewportWidth() < 1024 ? 0.95 : 0.97;
const getPlayStartScale = _ref2 => {
  let ticketInfo = _ref2.ticketInfo,
    wrapperSize = _ref2.wrapperSize;
  if (!(wrapperSize !== null && wrapperSize !== void 0 && wrapperSize.width)) {
    return getFallbackPlayStartScale();
  }
  const pickSizedWidth = getStoredPickSizedWidth(ticketInfo) || getPickSizedWidth(ticketInfo);
  if (!pickSizedWidth) {
    return getFallbackPlayStartScale();
  }
  const pickScale = clamp(pickSizedWidth / wrapperSize.width, 0.65, 1);
  return pickScale > getVisiblePlayStartLimit() ? getFallbackPlayStartScale() : pickScale;
};
const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_GAME_REF':
      return _objectSpread(_objectSpread({}, state), {}, {
        gameRef: action.payload
      });
    case 'SET_BET_ID':
      return _objectSpread(_objectSpread({}, state), {}, {
        betId: action.payload
      });
    default:
      return state;
  }
};
const parseBetId = _ref3 => {
  let wagerId = _ref3.wagerId,
    isDemo = _ref3.isDemo;
  if (!wagerId || isDemo) {
    return undefined;
  }
  const parsedWagerId = Number.parseInt(wagerId, 10);
  return Number.isNaN(parsedWagerId) ? undefined : parsedWagerId;
};
const getBackFaceIdString = _ref4 => {
  let betId = _ref4.betId,
    isDemo = _ref4.isDemo;
  if (betId) {
    return "Triss LottID ".concat(betId);
  }
  if (isDemo) {
    return 'PROVSPEL';
  }
  return '';
};
const GameLauncherWrapper = _ref5 => {
  var _svs$tickets$data, _ticketInfo$backImage, _ticketInfo$skins, _ticketInfo$skins2;
  let isDemo = _ref5.demo,
    gameIsCompleted = _ref5.gameIsCompleted,
    history = _ref5.history,
    _ref5$isCardFlipped = _ref5.isCardFlipped,
    isCardFlipped = _ref5$isCardFlipped === void 0 ? false : _ref5$isCardFlipped,
    onClose = _ref5.onClose,
    _ref5$onGameLoaded = _ref5.onGameLoaded,
    onGameLoaded = _ref5$onGameLoaded === void 0 ? NOOP : _ref5$onGameLoaded,
    skinId = _ref5.skinId,
    ticketInfo = _ref5.ticketInfo,
    wager = _ref5.wager,
    wagerId = _ref5.wagerId,
    topBarProps = _ref5.topBarProps;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isGameLoaded = _useState2[0],
    setIsGameLoaded = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasGameLoadingStarted = _useState4[0],
    setHasGameLoadingStarted = _useState4[1];
  const _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isGamePreviewVisible = _useState6[0],
    setIsGamePreviewVisible = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    arePlayControlsVisible = _useState8[0],
    setArePlayControlsVisible = _useState8[1];
  const _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isPlayStageExpanded = _useState0[0],
    setIsPlayStageExpanded = _useState0[1];
  const isGameExpanded = false;
  const _useState1 = useState({}),
    _useState10 = _slicedToArray(_useState1, 2),
    wrapperSize = _useState10[0],
    setWrapperSize = _useState10[1];
  const isFullScreenGame = ticketInfo.width === 0 && ticketInfo.height === 0;
  const showExpandButton = !isFullScreenGame;
  const expandOuterRef = useRef(null);
  const placeholderRef = useRef(null);
  const backFaceRef = useRef(null);
  const observedWrapperSizeRef = useRef(null);
  const loadingStartedAtRef = useRef(null);
  const initialBetId = parseBetId({
    wagerId,
    isDemo
  });
  const _useReducer = useReducer(reducer, {
      isDemo,
      ticketInfo,
      betId: initialBetId,
      isFullScreenGame,
      wager,
      gameIsCompleted
    }),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  const contextValue = useMemo(() => _objectSpread(_objectSpread({}, state), {}, {
    dispatch
  }), [state, dispatch]);
  const shouldShowReceipt = gameIsCompleted && isGameLoaded;
  const hasUnscratchedTicket = ((_svs$tickets$data = svs.tickets.data) === null || _svs$tickets$data === void 0 ? void 0 : _svs$tickets$data.fetchedGames) && svs.tickets.data.fetchedGames.length > 1;
  const updateWrapperSize = useCallback(size => {
    if (!size || isFullScreenGame) {
      return;
    }
    setWrapperSize(prevSize => {
      if (prevSize.width === size.width && prevSize.height === size.height) {
        return prevSize;
      }
      return size;
    });
  }, [isFullScreenGame]);
  useEffect(() => {
    if (isGameLoaded) {
      onGameLoaded();
    }
  }, [isGameLoaded, onGameLoaded]);
  useEffect(() => {
    if (isFullScreenGame || !wrapperSize.width || !wrapperSize.height) {
      setIsPlayStageExpanded(false);
      return undefined;
    }
    setIsPlayStageExpanded(false);
    const expandTimeout = window.setTimeout(() => {
      setIsPlayStageExpanded(true);
    }, PLAY_STAGE_EXPAND_DELAY_MS);
    return () => {
      window.clearTimeout(expandTimeout);
    };
  }, [isFullScreenGame, skinId, ticketInfo.type, wrapperSize.height, wrapperSize.width]);
  const startGameLoadingAnimation = useCallback(() => {
    if (!loadingStartedAtRef.current) {
      loadingStartedAtRef.current = Date.now();
    }
    setHasGameLoadingStarted(true);
  }, []);
  useEffect(() => {
    const handleGameLoading = () => {
      startGameLoadingAnimation();
    };
    addEventListener('GAME_LOADING', handleGameLoading);
    return () => {
      removeEventListener('GAME_LOADING', handleGameLoading);
    };
  }, [startGameLoadingAnimation]);
  useEffect(() => {
    if (!isGameLoaded) {
      setArePlayControlsVisible(false);
      setIsGamePreviewVisible(true);
      return undefined;
    }
    startGameLoadingAnimation();
    const loadingElapsedMs = Date.now() - loadingStartedAtRef.current;
    const previewHideDelayMs = Math.max(PLAY_LOADER_GROW_DURATION_MS - loadingElapsedMs, 0);
    const previewTimeout = window.setTimeout(() => {
      setIsGamePreviewVisible(false);
    }, previewHideDelayMs);
    const controlsTimeout = window.setTimeout(() => {
      setArePlayControlsVisible(true);
    }, previewHideDelayMs + PLAY_CONTROLS_DELAY_MS);
    return () => {
      window.clearTimeout(previewTimeout);
      window.clearTimeout(controlsTimeout);
    };
  }, [isGameLoaded, startGameLoadingAnimation]);
  useDefaultEventsLeiaFactory({
    ticketInfo,
    isDemo,
    wagerId,
    onClose
  });
  const _useCustomEvents = useCustomEvents({
      ticketInfo,
      isDemo,
      history,
      dispatch,
      setIsGameLoaded,
      hasUnscratchedTicket
    }),
    onPlayAgain = _useCustomEvents.onPlayAgain;
  const _useScratchDefaultEve = useScratchDefaultEventsLeiaFactory({
      demo: isDemo,
      ticketInfo,
      isFullScreenGame,
      onPlayAgain,
      onClose,
      shouldUseNextConfetti: true
    }),
    isLoading = _useScratchDefaultEve.isLoading,
    gameResult = _useScratchDefaultEve.gameResult,
    shouldShowPlayAgainFooter = _useScratchDefaultEve.shouldShowPlayAgainFooter,
    shouldShowBubbleWinMessage = _useScratchDefaultEve.shouldShowBubbleWinMessage;
  useEffect(() => {
    const init = async () => {
      const product = ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.branding;
      const extraParams = {
        amount: ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.price,
        product,
        branding: product
      };
      const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
      if (!isLoggedIn && !isDemo) {
        svs.components.customer_login.login({
          returnNewCustomer: true,
          extraParams
        });
      } else {
        var _svs, _svs$setupExtraData;
        await ((_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservices) === null || _svs === void 0 || (_svs = _svs.onboardingHandler) === null || _svs === void 0 || (_svs$setupExtraData = _svs.setupExtraData) === null || _svs$setupExtraData === void 0 ? void 0 : _svs$setupExtraData.call(_svs, {
          extraData: extraParams
        }));
      }
      svs.tickets.next.utils.utils.hideFooter();
    };
    init();
    return () => {
      svs.tickets.next.utils.utils.showFooter();
    };
  }, [isDemo, ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.branding, ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.price]);
  useEffect(() => {
    if (isFullScreenGame || !expandOuterRef.current || !placeholderRef.current) {
      observedWrapperSizeRef.current = null;
      return undefined;
    }
    return svs.tickets.next.utils.utils.observeContainedSize({
      container: expandOuterRef.current,
      target: placeholderRef.current,
      width: ticketInfo.width,
      height: ticketInfo.height,
      onUpdate: _ref6 => {
        let width = _ref6.width,
          height = _ref6.height;
        const nextSize = {
          width,
          height
        };
        observedWrapperSizeRef.current = nextSize;
        updateWrapperSize(nextSize);
      }
    });
  }, [isFullScreenGame, ticketInfo.height, ticketInfo.width, updateWrapperSize]);
  const onResize = useCallback(container => {
    if (isFullScreenGame) {
      const fullscreenSize = resizeFromFullscreen(container, ticketInfo);
      updateWrapperSize(fullscreenSize);
      return;
    }
    const observedSize = observedWrapperSizeRef.current;
    if (observedSize) {
      applyLauncherSize(container, observedSize);
      updateWrapperSize(observedSize);
      return;
    }
    const size = resizeFromTicketInfo(container, ticketInfo);
    if (!size) {
      return;
    }
    updateWrapperSize(size);
  }, [isFullScreenGame, ticketInfo, updateWrapperSize]);
  const wrapperStyles = isFullScreenGame || !wrapperSize.width || !wrapperSize.height ? {} : _objectSpread(_objectSpread({}, wrapperSize), {}, {
    margin: 'auto'
  });
  const bubbleWinOptions = _objectSpread({
    demo: isDemo,
    product: ticketInfo.type
  }, gameResult);
  const playAgainButtonText = ticketInfo.open ? "V\xE4lj ny ".concat(ticketInfo.name) : 'Välj ny lott';
  const shouldShowWinMessage = shouldShowBubbleWinMessage && !isFullScreenGame;
  const isTopBarLoading = !isGameLoaded;
  const topBarStyle = !isFullScreenGame && isGameLoaded ? {
    width: wrapperSize.width
  } : {};
  const handleTopBarClose = (topBarProps === null || topBarProps === void 0 ? void 0 : topBarProps.onClose) || NOOP;
  const handleTopBarInfoClick = event => {
    var _topBarProps$onInfoCl;
    if (isTopBarLoading) {
      var _event$preventDefault;
      event === null || event === void 0 || (_event$preventDefault = event.preventDefault) === null || _event$preventDefault === void 0 || _event$preventDefault.call(event);
      return;
    }
    topBarProps === null || topBarProps === void 0 || (_topBarProps$onInfoCl = topBarProps.onInfoClick) === null || _topBarProps$onInfoCl === void 0 || _topBarProps$onInfoCl.call(topBarProps, event);
  };
  const handleTopBarSoundClick = topBarProps === null || topBarProps === void 0 ? void 0 : topBarProps.onSoundClick;
  const topBarNode = React.createElement(NextTopBar, {
    isSoundOn: topBarProps === null || topBarProps === void 0 ? void 0 : topBarProps.isSoundOn,
    onClose: handleTopBarClose,
    onInfoClick: handleTopBarInfoClick,
    onSoundClick: handleTopBarSoundClick,
    trackingLabel: topBarProps === null || topBarProps === void 0 ? void 0 : topBarProps.trackingLabel
  });
  const holderClassName = gameResult ? 'game-complete' : '';
  const stageClassName = "next-play-ticket-stage".concat(isPlayStageExpanded ? ' next-play-ticket-stage--expanded' : '');
  const outerClassName = "next-play-stage u-relative".concat(isGameLoaded ? ' next-play-stage--loaded next-play-stage--zoomed' : '').concat(isCardFlipped ? ' next-play-stage--flipped' : '');
  const playStartScale = getPlayStartScale({
    ticketInfo,
    wrapperSize
  });
  const playStageStyle = {
    '--next-play-start-scale': String(playStartScale)
  };
  const isFlipActive = isCardFlipped && !isGameExpanded;
  const cardHostClassName = "next-play-card-host".concat(isFlipActive ? ' next-play-card-host--flipped' : '');
  const canMountGameLauncher = isFullScreenGame || Boolean(wrapperSize.width && wrapperSize.height);
  const gameSpecificParameters = {
    skinId: !(ticketInfo !== null && ticketInfo !== void 0 && ticketInfo.defaultSkin) && skinId ? skinId : 1
  };
  const backImageData = (ticketInfo === null || ticketInfo === void 0 || (_ticketInfo$backImage = ticketInfo.backImage) === null || _ticketInfo$backImage === void 0 ? void 0 : _ticketInfo$backImage.image) || (ticketInfo === null || ticketInfo === void 0 ? void 0 : ticketInfo.backImage);
  const launcherNode = React.createElement(GameWrapper, {
    className: "next-play-game-wrapper",
    context: contextValue,
    styles: wrapperStyles
  }, canMountGameLauncher && React.createElement(GameLauncherLeia, {
    className: "relative",
    gameSpecificParameters: gameSpecificParameters,
    onResize: onResize
  }, isGamePreviewVisible && React.createElement(GameLoader, {
    image: !isFullScreenGame && ((_ticketInfo$skins = ticketInfo.skins) === null || _ticketInfo$skins === void 0 || (_ticketInfo$skins = _ticketInfo$skins[skinId - 1]) === null || _ticketInfo$skins === void 0 ? void 0 : _ticketInfo$skins.image),
    isLoadingStarted: hasGameLoadingStarted
  }), !isLoading && React.createElement(TicketIdPopper, {
    hasTicketNumber: false
  }), isLoading && React.createElement(LoaderTicket, {
    image: !isFullScreenGame && ((_ticketInfo$skins2 = ticketInfo.skins) === null || _ticketInfo$skins2 === void 0 || (_ticketInfo$skins2 = _ticketInfo$skins2[skinId - 1]) === null || _ticketInfo$skins2 === void 0 ? void 0 : _ticketInfo$skins2.image)
  })));
  const gameLauncherContent = launcherNode;

  let backImageNode = null;
  if (backImageData) {
    const normalizedBackImage = typeof backImageData === 'string' ? {
      src: backImageData
    } : backImageData;
    backImageNode = React.createElement(Image, {
      cssSelectors: "next-play-card__back-image",
      image: _objectSpread(_objectSpread({}, normalizedBackImage), {}, {
        altText: (normalizedBackImage === null || normalizedBackImage === void 0 ? void 0 : normalizedBackImage.altText) || 'Baksida av lott'
      })
    });
  }
  const backFaceIdString = getBackFaceIdString({
    betId: state.betId,
    isDemo
  });
  const backFaceNode = React.createElement(GameWrapper, {
    className: "next-play-game-wrapper",
    context: contextValue,
    styles: wrapperStyles
  }, React.createElement("div", {
    className: "next-play-card__back-surface f-body",
    ref: backFaceRef
  }, backImageNode, backFaceIdString && React.createElement("h3", {
    className: "h3 ticket-id-popper--back"
  }, backFaceIdString)));
  let backFaceContent = backFaceNode;
  if (showExpandButton) {
    backFaceContent = React.createElement("div", {
      className: "ticket-expand relative padding-top-1"
    }, React.createElement("div", {
      className: "ticket-expand__game"
    }, backFaceNode), React.createElement("div", {
      className: "ticket-expand__shadow"
    }));
  }
  return React.createElement(React.Fragment, null, React.createElement(TicketPodiumStageFrame, {
    before: React.createElement(React.Fragment, null, shouldShowWinMessage && React.createElement("div", {
      className: "qa-win-message-container game-header relative"
    }, React.createElement(BubbleWinMessage, {
      options: bubbleWinOptions
    })), topBarProps && !shouldShowWinMessage && React.createElement("div", {
      className: "next-play-topbar".concat(arePlayControlsVisible ? ' next-play-topbar--visible' : '').concat(isTopBarLoading ? ' next-play-topbar--loading' : ''),
      style: topBarStyle
    }, React.createElement(GameContext.Provider, {
      value: {
        ticketInfo
      }
    }, topBarNode))),
    className: stageClassName,
    growAreaRef: expandOuterRef,
    holderClassName: holderClassName,
    placeholderRef: placeholderRef,
    ticketInfo: ticketInfo
  }, React.createElement("div", {
    className: outerClassName,
    style: playStageStyle
  }, React.createElement("div", {
    className: cardHostClassName
  }, React.createElement("div", {
    "aria-hidden": isFlipActive,
    className: "next-play-card-front-layer"
  }, gameLauncherContent), React.createElement("div", {
    "aria-hidden": !isFlipActive,
    className: "next-play-card-back-layer"
  }, backFaceContent)))), React.createElement(Receipt, {
    className: "next-ticket-receipt-margin-bottom",
    fetchedGame: wager,
    show: shouldShowReceipt,
    ticketInfo: ticketInfo
  }), shouldShowPlayAgainFooter && React.createElement(BottomSheet, null, React.createElement("div", {
    className: "u-flex u-flex-justify-content-center u-flex-column padding-2"
  }, React.createElement(Button, {
    block: true,
    className: "qa-play-again-btn",
    focus: true,
    onClick: onPlayAgain,
    type: "button"
  }, hasUnscratchedTicket ? 'Skrapa nästa lott' : playAgainButtonText))));
};
setGlobal('svs.tickets.next.areas.play.containers.GameLauncherWrapper', GameLauncherWrapper);

 })(window);